import { Component, OnInit,Input, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Console } from 'console';
import * as moment from 'moment';
import { EventEmitter } from '@angular/core';
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: "app-create-cashback",
  templateUrl: "./create-cashback.component.html",
  styleUrls: ["./create-cashback.component.scss"],
})
export class CreateCashbackComponent implements OnInit {
  Year = [2024, 2023, 2022, 2021];
  createCashback: any;
  submitted = false;
  currentDate = moment(new Date()).format("YYYY-MM-DD");
  minEndDate = this.currentDate;
  cashBackMode: any;
  transactionType: any;
  presentDate: any = "";

  // @Input() receiveData:any = ''
  @Output() newItemEvent = new EventEmitter<boolean>();
  @Output() cash_Back_id = new EventEmitter<any>();
  @Input() cashBackId: any;
  monthArray = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];

  constructor(
    private fb: FormBuilder,
    private route: Router,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService
  ) {
    this.presentDate = moment(new Date());
    this.createCashback = this.fb.group({
      Name: ["", Validators.required],
      startDate: ["", Validators.required],
      endDate: ["", Validators.required],
      month: ["", Validators.required],
      year: ["", Validators.required],
      cashback_mode: ["", Validators.required],
      amount: [0, [Validators.required, Validators.min(0)]],
      point_conv_value: ["1", [Validators.required, Validators.min(0)]],
      transaction_type: ["", Validators.required],
      transaction_fee: ["", [Validators.required, Validators.min(0)]],
      mininum_value: ["", [Validators.required, Validators.min(0)]],
      maximun_value: ["", [Validators.required, Validators.min(0)]],
    });
  }

  ngOnChanges() {
    this.monthList = this.monthArray;
    console.log(this.cashBackId);
    console.log(typeof this.cashBackId);
    if (this.cashBackId != 0) {
      this.getCashbackDetailsOnId();
    }
  }

  ngOnInit() {
    this.getCashbackMode();
    console.log(this.cashBackId);
  }

  nonNegativeValidator(control) {
    if (control.value < 0) {
      return { negative: true };
    }
    return null;
  }

  onchangeDate(dtype, e) {
    if (dtype == "startDate") return (this.minEndDate = e);
  }

  Submit(value) {
    console.log(this.createCashback);
    this.submitted = true;
    if (this.createCashback.invalid) {
      console.log("asasasas");
      return;
    }
    let payload = {
      name: this.createCashback.controls["Name"].value,
      start_date: this.createCashback.controls["startDate"].value,
      end_date: this.createCashback.controls["endDate"].value,
      month: this.createCashback.controls["month"].value,
      year: this.createCashback.controls["year"].value,
      cashback_mode: this.createCashback.controls["cashback_mode"].value,
      point: this.createCashback.controls["point_conv_value"].value,
      amount: this.createCashback.controls["amount"].value,
      transaction_type: this.createCashback.controls["transaction_type"].value,
      transaction_fee: this.createCashback.controls["transaction_fee"].value,
      min_value: this.createCashback.controls["mininum_value"].value,
      max_value: this.createCashback.controls["maximun_value"].value,
    };

    if (this.cashBackId == 0) {
      console.log(payload);
      this.apiService
        .post(this.apiConfig.createCashback, JSON.stringify(payload))
        .subscribe((res: any) => {
          try {
            console.log(res.body.data);
            this.cashBackId = res.body.data.cashback_id;
            this.toast.Success(res.body.data.message);
            this.newItemEvent.emit(true);
            this.cash_Back_id.emit(res.body.data.cashback_id);
          } catch (err) {
            console.log(err);
            this.toast.Error(res.body.data.message);
          }
        });
    } else {
      payload["id"] = this.cashBackId;
      console.log(payload);
      this.apiService
        .post(this.apiConfig.createCashback, JSON.stringify(payload))
        .subscribe((res: any) => {
          console.log(res.body.data);
          // this.cashBackId = res.body.data.cashback_id
          this.toast.Success(res.body.data.message);
          this.newItemEvent.emit(true);
          this.cash_Back_id.emit(this.cashBackId);
        });
    }
  }
  get f() {
    return this.createCashback.controls;
  }

  getCashbackMode() {
    this.apiService
      .get(this.apiConfig.getCashBackmode)
      .subscribe((res: any) => {
        console.log(res);
        this.cashBackMode = res.data;
      });
  }

  getCashbackDetailsOnId() {
    this.apiService
      .getHeaders(
        this.apiConfig.getCashBackList + `?program_id=1&id=${this.cashBackId}`
      )
      .subscribe((res: any) => {
        console.log(res.body.data, "aaaaaaaaaaaaaaaaaa");
        // patch or set value
        this.createCashback.controls["Name"].setValue(
          res.body.data.cashback_name
        );
        this.createCashback.controls["startDate"].setValue(
          res.body.data.start_date
        );
        this.createCashback.controls["endDate"].setValue(
          res.body.data.end_date
        );
        this.createCashback.controls["month"].setValue(
          res.body.data.cashback_month
        );
        this.createCashback.controls["year"].setValue(
          res.body.data.cashback_year
        );
        this.createCashback.controls["cashback_mode"].setValue(
          res.body.data.cashback_mode_id
        );
        this.createCashback.controls["transaction_fee"].setValue(
          res.body.data.transaction_fee
        );
        this.createCashback.controls["transaction_type"].setValue(
          res.body.data.transaction_fee_type
        );
        this.createCashback.controls["mininum_value"].setValue(
          res.body.data.min_transaction_amount
        );
        this.createCashback.controls["maximun_value"].setValue(
          res.body.data.max_transaction_amount
        );
        this.createCashback.controls["point_conv_value"].setValue(
          res.body.data.amount
        );
        this.createCashback.controls["amount"].setValue(res.body.data.amount);
        this.disableFeilds();
      });
  }
  disableFeilds() {
    this.createCashback.get("Name").disable();
    this.createCashback.get("startDate").disable();
    this.createCashback.get("endDate").disable();
    this.createCashback.get("month").disable();
    this.createCashback.get("year").disable();
    this.createCashback.get("cashback_mode").disable();
    this.createCashback.get("transaction_fee").disable();
    this.createCashback.get("transaction_type").disable();
    this.createCashback.get("mininum_value").disable();
    this.createCashback.get("maximun_value").disable();
    this.createCashback.get("amount").disable();
  }

  selectedItem(event, h) {
    console.log(event);
    console.log(h);
  }
  selectMonth(event) {}
  monthList = [];
  selectYear(event) {
    if (moment(this.presentDate).format("YYYY") == event.target.value) {
    let month= this.monthArray.filter((month) => {
        return month.id >= this.presentDate.format("MM");
      });
      this.monthList = month;

    }else{
      let month = []
      return this.monthList = this.monthArray;
    }
  }
}